export const SET_SIDEBAR = 'SET_SIDEBAR';
export const SET_ASIDE = 'SET_ASIDE';
export const SET_DARKMODE = 'USE_DARKMODE';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_ERROR = 'SHOW_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
